import { render, staticRenderFns } from "./_share_model_form.vue?vue&type=template&id=97c8ccb6&"
import script from "./_share_model_form.vue?vue&type=script&lang=js&"
export * from "./_share_model_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports